import { Picture } from "../../../Components/PhotosApp/PhotoViewer/PhotoInterfaces";
import Profile_1 from "./VaticanTweeterAssets/Tweeter-Pfp.webp";
import Tweet1Image from "./VaticanTweeterAssets/TweeterPic-1.webp";
import Tweet3Image from "./VaticanTweeterAssets/TweeterPic-2.webp";

export interface Comment {
  icon?: string;
  date: string;
  author: string;
  handle: string;
  likes: number;
  content: string;
}

export interface Tweet {
  icon?: string;
  date: string;
  time: string;
  author: string;
  handle: string;
  verified: string;
  content: string | Picture;
  contentImage?: string;
  likes: number;
  retweets: number;
  quotes: number;
  comments?: Comment[];
}

export const VaticanTweetContent: Tweet[] = [
  {
    icon: Profile_1,
    date: "18 APR 2025",
    time: "8:27 AM",
    author: "Vatican Insight",
    handle: "@vaticaninsightweb",
    verified: "Verified.webp",
    content:
      "#18April | On this day, 2025 years ago, Our Lord and Savior Jesus Christ was crucified on the cross #GoodFriday",
    contentImage: Tweet1Image,
    likes: 23400,
    retweets: 1500,
    quotes: 139,
  },
  {
    icon: Profile_1,
    date: "18 APR 2025",
    time: "11:34 AM",
    author: "Vatican Insight",
    handle: "@vaticaninsightweb",
    verified: "Verified.webp",
    content:
      '#18April | Pope Benedict’s gospel reflection for Good Friday.\n\n"Then said Jesus, Father, forgive them; for they know not what they do. And they parted his raiment, and cast lots." — Luke 23:34.\n\nLet us remember Jesus’ forgiveness on the cross this #GoodFriday',
    likes: 13100,
    retweets: 801,
    quotes: 98,
  },
  {
    icon: Profile_1,
    date: "18 APR 2025",
    time: "4:04 PM",
    author: "Vatican Insight",
    handle: "@vaticaninsightweb",
    verified: "Verified.webp",
    content:
      "#18April | Catholics around the world attended the Tre Ore mass from noon until 3pm today to commemorate the 3 hours of Christ’s hanging from the cross #GoodFriday",
    contentImage: Tweet3Image,
    likes: 18700,
    retweets: 1100,
    quotes: 148,
  },
];
